
import React from 'react';
import { Image, ScrollView, View } from 'react-native';
import { useSelector } from 'react-redux';
import Colors from '../../constants/Colorsv2';
import PollCampaignReviewWidget from './components/PollCampaignReviewWidget';



const PollReviewScreen = ({navigation, route, appHeight, insets}:any) => {

    const app_size:{ width:number } = useSelector((state:any) => state.util.app_size, (left, right) => left.width == right.width);
    return (
        <View style={{ height:appHeight, backgroundColor:Colors.brand.midnight, alignItems:'center' }}>
            <ScrollView 
                showsVerticalScrollIndicator={false} 
                style={{ flex:1, paddingTop:insets.top, paddingBottom:insets.bottom }}>
                <PollCampaignReviewWidget
                    width={app_size.width}
                    poll_campaign_id={route.params.poll_campaign_id}
                />
            </ScrollView>
            {false ?
            <View style={{position:'absolute', top:0, left:-100}}>
                <Image source={require('../../assets/images/background_vector.png')} style={{width:1206, height:111}}/>
            </View>
            :<></>}
        </View>
    )
}

export default PollReviewScreen